import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
//import { AttendeeList, Attendee } from '../libs/data-models/src';
import { PreferredCountries, DBUpdateMessage, STATUS } from '../libs/ceeyu-common/src';
import { firstValueFrom } from 'rxjs';
import { MatFormField, MatLabel, MatError, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { NgxMaskDirective} from 'ngx-mask';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDialogModule, MatDialog, MatDialogConfig, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatRadioButton } from "@angular/material/radio";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TextFieldModule } from '@angular/cdk/text-field';
import { AttendeeList, Attendee } from '../libs/data-models/src';
import { DbService } from '../service/db-service.service';
 
const emailRegex = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';
@Component({
    selector: 'ceeyu-inviteattendee',
    templateUrl: './inviteattendee.component.html',
    styleUrls: ['./inviteattendee.component.scss'],
    imports: [MatRadioModule, MatDialogModule, MatDialogContent, MatDialogActions,MatInputModule, MatButtonModule, MatFormFieldModule, TextFieldModule, MatTableModule, MatPaginatorModule, NgxMaskDirective, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, CdkTextareaAutosize, MatExpansionModule, MatError, MatRadioButton, MatHint,MatIconModule, MatCheckbox]
})
export class InviteattendeeComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('successfullyVerified') successfullyVerified!: TemplateRef<any>;
  @ViewChild('unableToVerify') unableToVerify!: TemplateRef<any>;
  editMode = false;
  showVerifyBtn = false;
  editRow = -1;
  pageSize: number = 5;
  pageIndex: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  verifiedAttendees: any[] = [];
  dataSource = new MatTableDataSource<any>(this.verifiedAttendees);
  displayedColumns = ['name'];
  predefinedCountriespredefinedCountries = new PreferredCountries().get();
  blkphone = [];
  selectedValue: string;
  productForm: FormGroup;
  invitedForm: FormGroup;
  messageForm: FormGroup;
  attendeeentry: AttendeeList;
  firebaseMessage: DBUpdateMessage;
  message = "";
  blockfnd = false;
  spphone: string;
  eventid: string;
  spname: string;
  eventtitle: string;
  fromdate: Date;
  todate: Date; 
  reminder: string = "";
  processAttendeePromise: Promise<any>[] = [];
  returnUrl: string;
  showAddAttendeeBtn = false;
  entryValid = false;
  attendeeValid = false;
  emailValid = false;
  phoneValid = false;
  doneAddingAttendees = false;
  attendeeListUpdated = false;
  
  constructor(private dbService: DbService,  private dialog: MatDialog, private dataService: DbService, private fb:FormBuilder, 
     private router: Router, private http: HttpClient) {
       this.eventid = this.dataService.selectedEvent.docid;
       this.eventtitle = this.dataService.selectedEvent.title;
       this.fromdate = this.dataService.selectedEvent.fromdate;
       this.todate = this.dataService.selectedEvent.todate;
       this.spname = this.dataService.selectedEvent.spname;
       this.spphone = this.dataService.selectedEvent.spphone;
       this.productForm = this.fb.group({
        name: new FormControl('', [Validators.required]),
        phone: new FormControl(undefined, [Validators.required, Validators.pattern(/^[0-9]\d{9}$/)]),
        email: new FormControl(undefined, [Validators.required, Validators.email, Validators.pattern(emailRegex)]),
      });
      this.invitedForm = this.fb.group({
         showgo: new FormControl(-1)
      });
      this.messageForm = this.fb.group({
        messageAudience:['messageNewlyAdded'],
        sendAllReminder: [`Please share photos and videos from ${this.eventtitle}`, [Validators.required, Validators.minLength(5), Validators.maxLength(200)]]
      });
  }

  ngOnInit(): void {
    this.message = "Please wait. Loading..."
    this.firebaseMessage = new DBUpdateMessage();
    this.attendeeentry = new AttendeeList();
    this.attendeeentry.attendees = [];
    this.attendeeentry.okphones = "";
    const event = JSON.stringify({
      "title": this.eventtitle,
      "id": this.eventid,
      "phone": this.spphone,
      "mode": "attendeelist"
    });
    firstValueFrom(this.dbService.sendPostUpdated(this.eventid,"all", event,"attendeelist",this.http))
    .then((resp) => {
      const res = resp["QueryResults"];
      if(res && res.length > 0){
        const arr = resp["QueryResults"][0]["attlist"]["attendees"];
        console.log("arr in inviteatt:" + JSON.stringify(arr));
        if(arr != undefined){
          arr.forEach((ele) => {
            this.verifiedAttendees.push({name: ele["name"], phone: ele["phone"], email: ele["email"], isnewlyadded: false});
          })
          this.dataSource.data = this.verifiedAttendees;
        }
      }
      this.message = "";
    });
  }
  
  onCancel(){
    this.editMode = false;
    this.showVerifyBtn = false;
    this.productForm.reset();
  }

  onVerify() {
    const element = this.productForm; 
    this.attendeeentry.eventid = this.eventid;
    if((this.blankStr("Name",element.get('name').value) || !element.get('phone').value || this.blankStr("Phone", element.get('phone').value))){
          this.message = "Please enter atleast one value to verify."
        return;
      }
      const tempPhone = "+1" + element.get('phone').value;
      firstValueFrom(this.dbService.verifyPhone(tempPhone,"blkchk",this.http))
      .then((response) => {
        const status = response["status"];
        if (status === "allow"){
          this.blockfnd = false;
          this.showAddAttendeeBtn = true;
          const name = this.productForm.get('name').value;
          let email = (this.productForm.get('email').value).toLowerCase();
          if(this.editMode){
             this.verifiedAttendees.splice(this.editRow, 1);
             this.editMode = false;
          } 
          this.verifiedAttendees.push({name: name, phone: tempPhone, email: email, isnewlyadded: true});
          this.attendeeListUpdated = true;
          this.dataSource.data = this.verifiedAttendees;
          this.productForm.reset();
          this.showVerifyBtn = false;
          this.dialog.open(this.successfullyVerified);
        }else{
          this.dialog.open(this.unableToVerify);
        }
        console.log("status:" + status + ":" + element.get('phone').value);  
      })
      .catch((err) => {
        console.log("error", err);
      })
  }

  blankStr(field, str){
    let ret = true;
    if(str && str.length > 0){
      ret = false;
    }else{
      this.message = "Please enter a value for" + field;
    }
    return ret;
  }
 
  onSubmit() {
    this.processAttendeePromise = [];
    this.reminder = this.messageForm.get('sendAllReminder').value;
    console.log("Message is:" + this.reminder);
    this.attendeeentry.eventid = this.eventid;
    this.verifiedAttendees.forEach( (element: any) => {
      this.processEntry(element);
    });

    if(this.blkphone.length>0){
     this.message = "Error: Please Remove Blocked Phones and Submit Again";
    }else{
      //if(this.attendeeentry.attendees.length > 0){
        this.processAttendeePromise.push(this.attendeeChanges());
        // 011126 not sure this.processAttendeePromise.push(this.attendeeStatus());
        Promise.all(this.processAttendeePromise)
        .then(() => {
          this.message = "Attendee list updated successfully";
          this.dbService.attendeesAdded = true;
          this.router.navigate(['eventsummary'], {skipLocationChange: true});
        });
      //}
    } 
  }
  
  async attendeeChanges(): Promise<any> {
    const audience = this.attendeeListUpdated?this.messageForm.get('messageAudience').value:"messageAll";
    try {
        const response = await firstValueFrom(this.dbService.processAttendeeChanges('addatt', audience, this.eventid, this.eventtitle, this.spphone, this.spname, this.attendeeentry,
        this.reminder, this.http));
        this.message = response["Message"];
    }catch(err) {
      console.log("error", err);
    }
  }

  async attendeeStatus(): Promise<any> {
    if(this.attendeeentry.attendees.length === 0){
      this.message = "Please create atleast one attendee before publishing";
      return Promise.resolve();
    }else{
    try{
        await firstValueFrom(this.dbService.processEventChangeStatus(this.eventid, STATUS.CLOSED, this.http));
        const tempUrl = this.returnUrl;
        console.log("tempUrl is:" + tempUrl);
        this.returnUrl = "choosenextstep";
        
        if(tempUrl != "noimages"){
          this.router.navigate([tempUrl], {skipLocationChange:true});
        }
      } catch (err) {
        console.log("error", err);
      }
    }
  }

  processEntry(element){
    let first = true;
    if(!element["block"]){
      const temp = new Attendee();
      temp.isNewlyAdded = element.isnewlyadded;
      temp.eventid = this.eventid;
      temp.eventtitle = this.eventtitle;
      temp.name = element.name;
      temp.phone = element.phone;
      temp.email = element.email ? element.email : "";
      this.attendeeentry.addUnique(temp);
      if(first){
        this.attendeeentry.okphones =  temp.phone;
        first = false;
      }else{
        this.attendeeentry.okphones = this.attendeeentry.okphones + ";" + temp.phone;
      }
    }else{
        const blk = {
        Number: element.phone,
        Name: element.name
      }
      this.blkphone.push(blk);
    }
  }

  goBack(){
    this.router.navigate(['eventsummary'], { skipLocationChange: true});
  }
   
  edit(element: any, row: number){
    this.productForm.get('name').setValue(element.name);
    this.productForm.get('email').setValue(element.email);
    this.productForm.get('phone').setValue(element.phone.replace("+1",""));
    this.editMode = true;
    this.editRow = row;
    this.doneAddingAttendees = false;
  }

  done(){
    this.doneAddingAttendees = true;
  }

  onInputChange($event: any){
    this.showVerifyBtn = this.productForm.valid;
  }
}
